import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Types } from 'src/app/constants/gift-card-type';

@Component({
  selector: 'app-form-my-gift-cards',
  templateUrl: './form-my-gift-cards.component.html',
  styleUrls: ['./form-my-gift-cards.component.scss'],
})
export class FormMyGiftCardsComponent implements OnInit {
  @Input() giftCardsAndCoupons: any[] = [];
  @Input() label: String = '';
  @Input() totalAmountForGiftCard = 0;
  public giftCards: any[] = [];
  public coupons: any[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.giftCards = this.giftCardsAndCoupons.filter(
      (x) => x.typeOfConsumption === parseInt(Types.GIFT_CARD)
    );
    this.coupons = this.giftCardsAndCoupons.filter(
      (x) => x.typeOfConsumption === parseInt(Types.COUPON)
    );
  }

  close() {
    this.modalController.dismiss();
  }
}
